module.exports = __webpack_public_path__ + "img/33_20.59bf5942.png";